import React, { useEffect, useRef } from 'react';

import * as PetitionFormStyled from '../EveryActionPetitionForm.styles';
import { MessageFields } from '../MessageFields';

import * as Styled from './MessageStepContent.styles';

import { TextButton } from '+/components/TextButton';
import { Button } from '+/components/Button';
import * as FormStyled from '+/styles/styledComponents/Form.styles';
import { t } from '+/utils/textDictionary';

export const MessageStepContent = ({
  onMessageStep,
  errors,
  values,
  handleChange,
  handleBlur,
  touched,
  advocacyFields,
  setOnMessageStep,
  setDisplayFormError,
  isSubmitting,
  handleSubmit,
  displayFormError,
}: MessageStepContentProps) => {
  const subjectInputRef = useRef<HTMLInputElement>(null);
  const messageStepEntryTimeRef = useRef<number>(0);

  useEffect(() => {
    if (onMessageStep && subjectInputRef.current) {
      messageStepEntryTimeRef.current = Date.now();
      // Autofocus and scroll to subject input after message step fade in to encourage editing
      setTimeout(() => {
        if (subjectInputRef.current) {
          subjectInputRef.current.focus({ preventScroll: true });
          const rect = subjectInputRef.current.getBoundingClientRect();
          const fullyInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (!fullyInViewport) {
            window.scrollBy({ top: rect.top - 125, behavior: 'smooth' });
          }
          subjectInputRef.current.setSelectionRange(0, 0);
          subjectInputRef.current.scrollLeft = 0;
        }
      }, 0);
    }
  }, [onMessageStep]);

  return (
    <Styled.Content
      initial={false}
      animate={{
        opacity: onMessageStep ? 1 : 0,
        visibility: 'visible',
        transitionEnd: { visibility: onMessageStep ? 'visible' : 'hidden' },
      }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
    >
      <MessageFields
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        intro={advocacyFields.intro}
        outro={advocacyFields.outro}
        subjectInputRef={subjectInputRef}
        variant="fill"
      />
      <PetitionFormStyled.ButtonRow centered>
        <PetitionFormStyled.ButtonContainer>
          <TextButton
            onClick={() => {
              setOnMessageStep(false);
              setDisplayFormError(false);
            }}
          >
            {t('EAAdvocacyForm.Back')}
          </TextButton>
          <PetitionFormStyled.SubmitButton>
            <Button
              narrow
              big
              type="submit"
              disabled={isSubmitting}
              onClick={() => {
                // Briefly disable send button on step change to prevent accidental click-through
                if (onMessageStep && Date.now() - messageStepEntryTimeRef.current < 400) return;
                handleSubmit();
              }}
            >
              {t('EAAdvocacyForm.SendMessage')}
            </Button>
          </PetitionFormStyled.SubmitButton>
        </PetitionFormStyled.ButtonContainer>
        {displayFormError && (
          <FormStyled.InputError>{t('EAPetitionForm.FormError')}</FormStyled.InputError>
        )}
      </PetitionFormStyled.ButtonRow>
    </Styled.Content>
  );
};
